export default __webpack_public_path__ + "static/media/supremelich.4811c85b.png";